import type Highcharts from "highcharts";

declare module "highcharts" {
  interface Chart {
    seriesGroup: SVGElement | null;
  }

  interface PlotLineOrBand {
    axis: Highcharts.Axis;
    options: Highcharts.PlotLineOptions;
  }
}

// https://github.com/highcharts/highcharts/issues/3321
export default function fixPlotlinesZIndex(H: typeof Highcharts) {
  H.wrap(
    H.PlotLineOrBand.prototype,
    "render",
    function (
      this: Highcharts.PlotLineOrBand,
      proceed: { call: (arg: Highcharts.PlotLineOrBand) => void },
    ) {
      const chart = this.axis.chart;

      proceed.call(this);

      if (!chart.seriesGroup) {
        chart.seriesGroup = chart.renderer.g("series-group").attr({ zIndex: 3 }).add();
      }

      if (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.svgElem as any).parentGroup !== chart.seriesGroup
      ) {
        this.svgElem.attr({ zIndex: this.options.zIndex }).add(chart.seriesGroup);
      }
      return this;
    },
  );
}
